export const uploadMarkupRootScope = {
    isResetted: false,
    escape: false,
};

export const shapeTextObj = { 1: "FREEDRAW", 2: "RECT", 3: "TEXT", 4: "CIRCLE", 5: "MASK", 6: "ARROW" };
export const MarkupTextSize = 24;
export const MarkupLargeTextSize = 34;
export const uploadFilesMarkupLargeTextSize = 58;
export const uploadFilesMarkupiosTextSize = 70;

export const MOUSE_EVENTS = {
    DOWN: "down",
    MOVE: "move",
    UP: "up",
};

export const MaximumCharInOneLine = 18;
export const MaximumCharForText = 36;

export const MARKUP_MENU_TYPE = {
    MARKUP_ANNOTATION: "MARKUP_ANNOTATION",
    UPLOAD_MARKUP: "UPLOAD_MARKUP",
};

export const INCREASE = "increase";
export const DECREASE = "decrease";
